"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectionManager = void 0;
const schemas_1 = require("@dcl/schemas");
const abis_1 = require("../abis");
exports.collectionManager = {
    [schemas_1.ChainId.MATIC_MUMBAI]: {
        version: '1',
        abi: abis_1.abis.CollectionManager,
        address: '0xe539E0AED3C1971560517D58277f8dd9aC296281',
        name: 'Decentraland Collection Manager',
        chainId: schemas_1.ChainId.MATIC_MUMBAI
    },
    [schemas_1.ChainId.MATIC_MAINNET]: {
        version: '1',
        abi: abis_1.abis.CollectionManager,
        address: '0x9D32AaC179153A991e832550d9F96441Ea27763A',
        name: 'Decentraland Collection Manager',
        chainId: schemas_1.ChainId.MATIC_MAINNET
    }
};
//# sourceMappingURL=collectionManager.js.map